import { render, staticRenderFns } from "./AudioSettingModal.vue?vue&type=template&id=babcf974&"
import script from "./AudioSettingModal.vue?vue&type=script&lang=js&"
export * from "./AudioSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports